import { isEmpty, startCase } from "lodash";
import React, { useContext, useState } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import obj from "../../utils/constants";
import DropDown from "./DropDown";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import { FancyListDropdown } from "./FancyListDropdown";
import { Link, useNavigate } from "react-router-dom";
import iconfromto from "../../assets/images/icon-fromto.png";

const FancyBetTypeListingNew = ({
  title,
  data,
  getFancyData,
  fancyOdds,
  setFancyOddds,
  grouped,
  others,
  setFancyOddData,
  fancyOddsOld,
}) => {
  const [showMatch, setShowMatch] = useState(false);
  let { user } = useContext(AuthContext);
  const [selectData, setSelectData] = useState([]);
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const FancyMulti = ({ data, index, indexNew, type }) => {
    index = 0;
    return data?.map((res, innerIndex) => {
      return (
        <>
          <tr key={index + 1}>
            {index == innerIndex && (
              <>
                <td className="text-start" rowSpan={data?.length + 1}>
                  <p className="blue-text">
                    {startCase(
                      res?.eventType === "4"
                        ? "Cricket"
                        : res?.eventType === "1"
                        ? "Soccer"
                        : res?.eventType === "2"
                        ? "Tennis"
                        : "Casino"
                    )}
                  </p>
                </td>
                <td className="text-start" rowSpan={data?.length + 1}>
                  {helpers.matchDateTimeNew(res?.eventDateTime, user.timeZone)}
                </td>
              </>
            )}
            <td className="bg-yellow border-0 risk-match-name">
              <a>
                <>
                  {res?.marketId == id ? (
                    <Button
                      onClick={() => {
                        setShowMatch(false);
                        setSelectData("");
                        setId("");
                        getFancyData(res?.eventId, res?.selectionId);
                        setFancyOddData({});

                        setFancyOddds({});
                      }}
                      className={"angle-up"}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        setShowMatch(true);
                        setId(res?.marketId);
                        setFancyOddData({
                          eventId: res?.eventId,
                          selectionId: res?.selectionId,
                        });
                        setSelectData(res?.odds);
                        getFancyData(res?.eventId, res?.selectionId);
                      }}
                      className={"angle-up down-up"}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Button>
                  )}
                </>
                {/* <Button
                  style={{
                    padding: "3px 5px",
                    fontSize: "12px",
                    marginRight: "5px",
                  }}
                  onClick={() =>
                    navigate(
                      `/match-details/${res?.eventId}/${res?.marketId}`
                    )
                  }
                >
                  View Details
                </Button> */}
                <strong style={{ marginLeft: "10px" }}>
                  <Link
                  // to={`/match-details/${res?.eventId}/${res?.marketId}`}
                  >
                    {res?.matchName}
                  </Link>
                </strong>{" "}
                <img className="fromto" src={iconfromto} />
                <span className="ms-3">{res?.fancyName} </span>
              </a>
            </td>
            <td className="border-0 bg-yellow text-end">
              <p className="text-danger">
                {res?.positionLoseAmount
                  ? "(" +
                    helpers.currencyFormat(Math.abs(res?.positionLoseAmount)) +
                    ")"
                  : 0}
              </p>
            </td>

            {/* <td className="border-0 bg-yellow text-end"></td> */}

            <td className="border-0 bg-yellow text-end">
              <p className="text-success text-danger-new">
                {res?.positionProfitAmount
                  ? helpers.currencyFormat(res?.positionProfitAmount)
                  : 0}
              </p>
            </td>
            <td className="border-right-0 text-center">
              <Link
                // to={`/DownlinePnl-Fancy/${res?.fancyName}/${res?.eventId}/${res?.marketId}/${res?.selectionId}`}
                // target="_blank"
                onClick={() =>
                  window
                    .open(
                      `/DownlinePnl-Fancy/${res?.fancyName}/${res?.eventId}/${res?.marketId}/${res?.selectionId}`,
                      "_blank",
                      "width=500, height=700"
                    )
                    .focus()
                }
                className="view-btn b-book"
              >
                {"Book"}
              </Link>
            </td>
          </tr>
          {res?.marketId == id ? (
            <FancyListDropdown
              showMatch={showMatch}
              data={res?.jsonData}
              selectData={selectData}
              res={res}
              title={title}
              fancyOdds={
                fancyOdds?.rt?.length > 0 &&
                res?.selectionId == fancyOdds?.selectionId
                  ? fancyOdds?.rt
                  : []
              }
              fancyOddsOld={
                fancyOddsOld?.rt?.length > 0 &&
                res?.selectionId == fancyOddsOld?.selectionId
                  ? fancyOddsOld?.rt
                  : []
              }
            />
          ) : (
            ""
          )}
        </>
      );
    });
  };
  return (
    <div className="risk-management-table">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h2 className="common-heading">{title}</h2>
        <div>
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            Download
          </Button>{" "}
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            <i
              style={{ transform: "rotateY(180deg)" }}
              className="fas fa-redo-alt"
            ></i>
          </Button>
        </div>
      </div>

      <div className="account-table match-odd-table risk-fancy-data">
        <div className="responsive">
          <Table>
            <thead>
              <tr>
                <td width="10%" rowSpan="2">
                  <strong> Sports</strong>
                </td>
                <td width="10%" rowSpan="2">
                  <strong> Market Date</strong>
                </td>
                <td rowSpan="2">
                  <strong>Event/Market Name</strong>
                </td>
                <td
                  width="21%"
                  className="text-center border-l bg-light-yellow"
                  colSpan="2"
                >
                  <strong>Player P/L</strong>
                </td>
                <td width="6%" rowSpan="2" className="text-center">
                  <strong> Books</strong>
                </td>
              </tr>
              <tr>
                <td width="7%" className="bg-light-yellow left-border t-right">
                  <strong> MIN</strong>
                </td>

                <td
                  width="7%"
                  className="bg-light-yellow right-border t-right "
                >
                  <strong>{"MAX"}</strong>
                </td>
              </tr>
            </thead>

            {grouped?.length > 0 || others?.length > 0 ? (
              <>
                {grouped?.map((res, index) => {
                  return (
                    <tbody className="match-tbody">
                      <FancyMulti
                        type={"multi"}
                        data={res}
                        index={index}
                        indexNew={index}
                      />
                    </tbody>
                  );
                })}
                {/* {others?.map((res, index) => {
                  return (
                    <tbody className="match-tbody">
                      <FancyMulti
                        type={"multi"}
                        data={res}
                        index={index}
                        indexNew={index}
                      />
                    </tbody>
                  );
                })} */}
                {/* {second?.others?.length > 0 && (
                  <tbody className="match-tbody">
                    <BetFair type={'multi'} data={second?.others} />
                  </tbody>
                )} */}
              </>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={7}>No Data</td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default FancyBetTypeListingNew;
